import PoleIcon from './component'

export default PoleIcon
